import React from 'react'
import { GatsbyImage, StaticImage, getImage } from 'gatsby-plugin-image'
import parser from 'html-react-parser'
import OurImpactMapSlider from '@components/OurImpact/OurImpactMapSlider';

export default function Video2({data}) {
    const {video2ButtonText, video2ButtonLink, video2Url, video2Title, video2ShowMap, video2Icon, video2ButtonExternalLink} = data
    return (
        <div className='our-imapct-video-wrap global-comet-vid-wrap light-grey-bg'>
            <div className='container imapct-vid-cont'>
                <div className='row'>
                    <div className='col-md-12 text-center'>
                        <figure className='abt-origins-icon mb-3'>
                            <GatsbyImage image={getImage(video2Icon?.localFile)}                                
                                alt='image'
                            />
                        </figure>
                        <div className='imapact-vid-sec our-impact-vid-sec'>
                            <iframe
                                width='560'
                                height='488'
                                src={video2Url}
                                title='YouTube video player'
                                allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
                                allowFullScreen
                            ></iframe>
                            {video2Title && parser(video2Title)}
                        </div>
                    </div>
                </div>
            </div>
            {video2ShowMap && <OurImpactMapSlider />}
        </div>
    )
}
